/** Raised for a region slug the server does not know, which is a 404 not a
 *  404-shaped empty list — the page says so rather than showing an empty list. */
export class RegionNotFoundError extends Error {
  constructor(slug: string) {
    super(`No region matches “${slug}”`);
    this.name = 'RegionNotFoundError';
  }
}
